// extracted by mini-css-extract-plugin
export var card = "_sh-0";
export var details = "_sh-1";